import { AutoMap } from "@automapper/classes";
import { ActivityTypeDto } from "./activity-type.dto";

export class ActivityTypeResponseDto {

    @AutoMap()
  public content!: ActivityTypeDto[];

}